"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.InvalidDevice = exports.InvalidNotificationChannel = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../openapi");
const notification_1 = require("../../shared/notification");
const Notification = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Notification.Spec';
const ChannelListResponse = openapi_1.Response.Success(Notification.ChannelList).annotations({
    description: 'Notification channels of the signed-in user',
});
const ChannelCreateResponse = openapi_1.Response.Success(notification_1.ChannelCreateResult).annotations({
    description: 'Created notification channel; data is empty today',
});
const ChannelUpdateResponse = openapi_1.Response.Success(notification_1.ChannelUpsertResult).annotations({
    description: 'Updated notification channel',
});
const NotificationListResponse = openapi_1.Response.Success(Notification.NotificationList).annotations({
    description: 'Notification rules of the signed-in user',
});
const EmptySuccessResponse = openapi_1.Response.EmptyData.annotations({
    description: 'Successful notification mutation',
});
exports.InvalidNotificationChannel = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidNotificationChannel`, 'INVALID_NOTIFICATION_CHANNEL', 'Invalid Notification Channel', 'An entry of channelIds is not a notification channel of the signed-in user. channelId carries the first such entry.', { channelId: effect_1.Schema.String });
exports.InvalidDevice = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidDevice`, 'INVALID_DEVICE', 'Invalid Device', 'An entry of deviceSerialNumbers is not a device owned by the signed-in user. deviceId carries the first such serial number.', { deviceId: effect_1.Schema.String });
const ruleChecks = 'The checks run in this order once the payload is valid: the scope (401 for any value other than device, which is also the default), the channel ids (422 INVALID_NOTIFICATION_CHANNEL for the first id that is not a channel of the signed-in user), then the serial numbers (422 INVALID_DEVICE for the first one that is not a device owned by the signed-in user).';
const ruleStorage = 'The rule is stored active. When triggerType is connection and gracePeriod is absent, gracePeriod is stored as 600. Optional fields that are not sent are stored as null, except the lists (stored as empty lists), scope (stored as device) and minInterval (stored as 0). A valueThreshold of 0 or false and a gracePeriod of 0 are stored as null.';
const templateSubstitutions = 'Message templates support {{SERIAL_NUMBER}} ({{DEVICE_ID}} is an alias), {{PROPERTY_VALUE}} and {{DATA.key}}. Email templates also get the device fields {{ACCOUNT_NUMBER}}, {{CONTACT_NAME}}, {{EMAIL_ADDRESS}}, {{PHONE_NUMBER}}, {{ADDRESS}}, {{ADDITIONAL_ADDRESS}}, {{CITY}}, {{POSTAL_CODE}}, {{MSN}}, {{SKU}} and {{DEALER_ID}}; push and SMS templates get them as empty strings.';
const channelCreateResult = 'The answer does not carry the id of the new channel: data is empty, so read the id from GET /channels.';
const channelReplace = 'The stored channel is replaced as a whole and kept active, and createdAt is set to the time of the update. The channel type is not checked: when the id belongs to a channel of another type, a new channel of this type is saved under the same id and the original stays.';
const channelOwner = 'Answers 404 when the channel does not exist, and 401 when it belongs to another user or was created by another client application than the one of the current session. Payload validation (422) runs first.';
const channelSession = 'A token without a client application session is answered with 500.';
const listChannels = platform_1.HttpApiEndpoint.get('listChannels') `/channels`
    .addSuccess(ChannelListResponse)
    .annotate(platform_1.OpenApi.Title, 'List Notification Channels')
    .annotate(platform_1.OpenApi.Description, `Lists the notification channels of the signed-in user, webhook channels included. editable is true for the channels created by the client application of the current session. The owner and client application ids are not returned. ${channelSession}`)
    .pipe(openapi_1.Error.withV1StandardErrors);
const deleteChannel = platform_1.HttpApiEndpoint.del('deleteChannel') `/channels`
    .setPayload(Notification.ChannelDeletePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(openapi_1.Error.V1NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'Delete Notification Channel')
    .annotate(platform_1.OpenApi.Description, `Deletes a notification channel by channelId. ${channelOwner} Rules that list the channel keep its id. ${channelSession}`)
    .pipe(openapi_1.Error.withV1StandardErrors);
const createMobileChannel = platform_1.HttpApiEndpoint.post('createMobileChannel') `/channel/mobile`
    .setPayload(Notification.MobileChannelCreatePayload)
    .addSuccess(ChannelCreateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Mobile Notification Channel')
    .annotate(platform_1.OpenApi.Description, `Creates an active mobile push channel owned by the signed-in user and bound to the client application of the current session. tokenType defaults to message and deliveryMethod to fcm. ${channelCreateResult} ${channelSession}`)
    .pipe(openapi_1.Error.withV1StandardErrors);
const updateMobileChannel = platform_1.HttpApiEndpoint.put('updateMobileChannel') `/channel/mobile`
    .setPayload(Notification.MobileChannelUpdatePayload)
    .addSuccess(ChannelUpdateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(openapi_1.Error.V1NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'Update Mobile Notification Channel')
    .annotate(platform_1.OpenApi.Description, `Replaces a mobile push channel. ${channelOwner} ${channelReplace} ${channelSession}`)
    .pipe(openapi_1.Error.withV1StandardErrors);
const createEmailChannel = platform_1.HttpApiEndpoint.post('createEmailChannel') `/channel/email`
    .setPayload(Notification.EmailChannelCreatePayload)
    .addSuccess(ChannelCreateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Email Notification Channel')
    .annotate(platform_1.OpenApi.Description, `Creates an active email channel owned by the signed-in user and bound to the client application of the current session. ${channelCreateResult} ${channelSession}`)
    .pipe(openapi_1.Error.withV1StandardErrors);
const updateEmailChannel = platform_1.HttpApiEndpoint.put('updateEmailChannel') `/channel/email`
    .setPayload(Notification.EmailChannelUpdatePayload)
    .addSuccess(ChannelUpdateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(openapi_1.Error.V1NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'Update Email Notification Channel')
    .annotate(platform_1.OpenApi.Description, `Replaces an email channel. ${channelOwner} ${channelReplace} ${channelSession}`)
    .pipe(openapi_1.Error.withV1StandardErrors);
const createSmsChannel = platform_1.HttpApiEndpoint.post('createSmsChannel') `/channel/sms`
    .setPayload(Notification.SmsChannelCreatePayload)
    .addSuccess(ChannelCreateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create SMS Notification Channel')
    .annotate(platform_1.OpenApi.Description, `Creates an active SMS channel owned by the signed-in user and bound to the client application of the current session. ${channelCreateResult} ${channelSession}`)
    .pipe(openapi_1.Error.withV1StandardErrors);
const updateSmsChannel = platform_1.HttpApiEndpoint.put('updateSmsChannel') `/channel/sms`
    .setPayload(Notification.SmsChannelUpdatePayload)
    .addSuccess(ChannelUpdateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(openapi_1.Error.V1NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'Update SMS Notification Channel')
    .annotate(platform_1.OpenApi.Description, `Replaces an SMS channel. ${channelOwner} ${channelReplace} ${channelSession}`)
    .pipe(openapi_1.Error.withV1StandardErrors);
const listNotifications = platform_1.HttpApiEndpoint.get('listNotifications') ``
    .addSuccess(NotificationListResponse)
    .annotate(platform_1.OpenApi.Title, 'List Notifications')
    .annotate(platform_1.OpenApi.Description, 'Lists the notification rules of the signed-in user. The stored id is returned as both notificationId and ruleId, and the owner id is not returned.')
    .pipe(openapi_1.Error.withV1StandardErrors);
const createNotification = platform_1.HttpApiEndpoint.post('createNotification') ``
    .setPayload(Notification.NotificationCreatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.InvalidNotificationChannel)
    .addError(exports.InvalidDevice)
    .addError(openapi_1.Error.V1NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'Create Notification')
    .annotate(platform_1.OpenApi.Description, `Creates a notification rule owned by the signed-in user. ${ruleChecks} ${ruleStorage} ${templateSubstitutions}`)
    .pipe(openapi_1.Error.withV1StandardErrors);
const updateNotification = platform_1.HttpApiEndpoint.put('updateNotification') ``
    .setPayload(Notification.NotificationUpdatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.InvalidNotificationChannel)
    .addError(exports.InvalidDevice)
    .addError(openapi_1.Error.V1NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'Update Notification')
    .annotate(platform_1.OpenApi.Description, `Replaces the notification rule with the given notificationId; ruleId is accepted as an alias when notificationId is absent, and one of them is required. ${ruleChecks} The rule itself is not looked up: the document is saved under the signed-in user, so an unknown id creates a new rule and answers 200. ${ruleStorage} Fields that are not sent are reset, and createdAt is set to the time of the update. ${templateSubstitutions}`)
    .pipe(openapi_1.Error.withV1StandardErrors);
const deleteNotification = platform_1.HttpApiEndpoint.del('deleteNotification') ``
    .setPayload(Notification.NotificationDeletePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(openapi_1.Error.V1NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'Delete Notification')
    .annotate(platform_1.OpenApi.Description, 'Deletes the notification rule with the given notificationId; ruleId is accepted as an alias when notificationId is absent, and one of them is required. Only notificationId is validated (422). Answers 404 when no rule has that id and 401 when the rule belongs to another user.')
    .pipe(openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.frontend.notification')
    .add(listChannels)
    .add(deleteChannel)
    .add(createMobileChannel)
    .add(updateMobileChannel)
    .add(createEmailChannel)
    .add(updateEmailChannel)
    .add(createSmsChannel)
    .add(updateSmsChannel)
    .add(listNotifications)
    .add(createNotification)
    .add(updateNotification)
    .add(deleteNotification)
    .middleware(openapi_1.Security.V1AuthenticatedUser)
    .prefix('/notifications')
    .annotate(platform_1.OpenApi.Title, 'User Notifications')
    .annotate(platform_1.OpenApi.Description, 'Notification rules and delivery channels (email, mobile, SMS) of the signed-in user')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.User));
//# sourceMappingURL=spec.js.map